module.exports = __webpack_public_path__ + "img/join-2-en.94a4cd4e.png";